<template>
  <div>
    <loadingCube v-if="!tax_hmrc_loaded" :loadingMessage="'GENIUS TAX SERVICE'"></loadingCube>
    <div v-else-if="tax_hmrc_loaded">
      <!--  <div v-if="!notEmptyObject(tax_hmrc)" id="no_tax_sign_up" class="d-flex align-items-center">-->
      <!-- Worker Signed up to tax service -->
      <div v-if="!worker.rel_services.genius_tax" id="no_tax_sign_up" class="d-flex align-items-center">
        <div class="container text-center" style="width: 375px;">
          <h4 class="font-weight-bold mb-3">NOT SIGNED UP FOR TAX SERVICE</h4>
          <button @click="sign_up_to_tax_service" class="btn orcaBtn greenBtn">Click Here to sign up worker</button>
        </div>
      </div>
      <div v-if="worker.rel_services.genius_tax && notEmptyObject(tax_hmrc) && Object.keys(tax_hmrc).length > 1" class="row">
        <div class="col-12">
          <b-card header="Tax Service Details" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
            <div class="row">
              <div class="col-xl-4 form-group">
                <label class="form-label" for="tax_commission">Consultant due Tax Commission</label>
                <p id="tax_commission" v-if="tax_hmrc.commission_user !== null">{{ tax_hmrc.commission_user.first_name }} {{ tax_hmrc.commission_user.surname }}</p>
              </div>
              <div class="col-xl-4 form-group">
                <label class="form-label" for="tax_sign_up_date">Date signed up for Tax Service</label>
                <p id="tax_sign_up_date">{{ tax_hmrc.signup_date | formatDate }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 form-group">
                <label class="form-label" for="tax_return_total_cost">Tax Return Total Cost</label>
                <p id="tax_return_total_cost">
                  <span v-if="tax_hmrc.tax_return_total_cost !== null">{{ tax_hmrc.tax_return_total_cost | currency }}</span><span v-else>-</span>
                </p>
              </div>
              <div class="col-xl-4 form-group">
                <label class="form-label" for="tax_return_cost_per_week">Tax Return Cost Per Week</label>
                <p id="tax_return_cost_per_week">
                  <span v-if="tax_hmrc.tax_return_cost_per_week !== null">{{ tax_hmrc.tax_return_cost_per_week | currency }}</span><span v-else>-</span>
                </p>
              </div>
              <div class="col-xl-4 form-group">
                <label class="form-label" for="paid_toward_tax">Paid towards this years Tax Service</label>
                <p id="paid_toward_tax">
                  -
                </p>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-12" v-if="
         ($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) ||
         (
         tax_details.docs_sent_date === null ||
         (tax_details.hmrc_648_file_path === null || tax_details.self_ass_dec_form_file_path === null || tax_details.terms_engagement_file_path === null) ||
         tax_details.sent_hmrc_648_date === null ||
         (tax_details.received_auth_code_date === null && tax_details.sent_hmrc_648_date !== null) ||
         (tax_details.quickfile_account_created_date === null && tax_details.received_auth_code_date !== null)
         )">
          <b-card header="Tax Service Actions" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
            <div class="row" v-if="show_action_buttons">
              <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))" class="col-6 form-group">
                <button @click="take_action('change_sign_up_date')" class="btn orcaBtn grey_bg w-100 sm_btn">Change Sign Up Date</button>
              </div>
              <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))" class="col-6 form-group">
                <button @click="take_action('change_commission_consultant')" class="btn orcaBtn grey_bg w-100 sm_btn">Change Commission Consultant</button>
              </div>
              <div v-if="tax_details.docs_sent_date === null" class="col-xl-4 form-group">
                <button @click="take_action('docs_manually_sent')" class="btn orcaBtn grey_bg w-100 sm_btn">Docs Manually sent</button>
              </div>
              <!--       <div v-if=" tax_details.hmrc_648_file_path === null || tax_details.self_ass_dec_form_file_path === null || tax_details.terms_engagement_file_path-->
              <!--    === null" class="col-xl-4 form-group">-->
              <div v-if="!check_up_file_1 || !check_up_file_2 || !check_up_file_3" class="col-xl-4 form-group">
                <button @click="take_action('upload_received_docs')" class="btn orcaBtn w-100 sm_btn">Upload received document</button>
              </div>
              <div v-if="check_up_file_3 && tax_details.sent_hmrc_648_date === null" class="col-xl-4 form-group">
                <button @click="take_action('sent_64_8_to_hmrc')" class="btn orcaBtn w-100 sm_btn">64/8 sent to HMRC</button>
              </div>
              <div v-if="tax_details.received_auth_code_date === null && tax_details.sent_hmrc_648_date !== null" class="col-xl-4 form-group">
                <button @click="take_action('auth_code_received')" class="btn orcaBtn w-100 sm_btn">Authorisation Code Received</button>
              </div>
              <div v-if="tax_details.quickfile_account_created_date === null && tax_details.received_auth_code_date !== null" class="col-xl-4 form-group">
                <button @click="take_action('quickfile_account_created')" class="btn orcaBtn w-100 sm_btn">Quickfile account created</button>
              </div>
            </div>
            <div v-else>
              <ValidationObserver ref="saveActionForm" slim>
                <form role="form" @submit.prevent="save_action">
                  <!-- commission consultant -->
                  <div v-if="action === 'change_commission_consultant'" class="row">
                    <div class="col-xl-6 form-group">
                      <label class="form-label" for="tax_commission_current">Current Tax Commission Consultant</label>
                      <p id="tax_commission_current">{{ tax_hmrc.commission_user.first_name }} {{ tax_hmrc.commission_user.surname }}</p>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="New Tax Commission Consultant" tag="div" class="form-group">
                        <label class="form-label" for="tax_commission_new">New Tax Commission Consultant</label>
                        <multiselect v-model="new_actions.commission_user" id="tax_commission_new" class="requiredField" :class="classes" name="tax_commission_new" placeholder=""
                                     :custom-label="consultant_label" :options="ms_opts.commission_users"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- sign up date -->
                  <div v-if="action === 'change_sign_up_date'" class="row">
                    <div class="col-xl-6 form-group">
                      <label class="form-label" for="signup_date_current">Current Sign Up Date</label>
                      <p id="signup_date_current">{{ tax_hmrc.signup_date | formatDate }}</p>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="New Sign Up Date" tag="div">
                        <label class="form-label" for="new_signup_date">New Sign Up Date</label>
                        <datepicker v-model="new_actions.signup_date" id="new_signup_date" name="new_signup_date" :input-class="['date-input', 'requiredField', classes]"
                                    :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_new_signup_date" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- manually sent docs -->
                  <div v-if="action === 'docs_manually_sent'" class="row">
                    <div class="col-12 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="Date Documents manually sent" tag="div">
                        <label class="form-label" for="docs_manually_sent_date">Date Documents manually sent</label>
                        <datepicker v-model="new_actions.docs_sent_date" id="docs_manually_sent_date" name="docs_manually_sent_date"
                                    :input-class="['date-input', 'requiredField', classes]"
                                    :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_docs_manually_sent_date" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Documents upload -->
                  <div v-if="action === 'upload_received_docs'" class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Upload received document</h4>
                    </div>
                    <div class="col-xl-4 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="Tax file to upload" tag="div" class="form-group">
                        <label class="form-label" for="file_to_upload">Tax file to upload</label>
                        <multiselect v-model="new_actions.file_to_upload" id="file_to_upload" class="file_to_upload requiredField" :class="classes" name="file_to_upload"
                                     placeholder="" :options="ms_opts.file_to_upload"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-xl-4 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="Received date of file to upload" tag="div">
                        <label class="form-label" for="file_received_date">Received date of file to upload</label>
                        <datepicker v-model="new_actions.file_received_date" id="file_received_date" name="file_received_date"
                                    :input-class="['date-input', 'requiredField', classes]"
                                    :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_file_received_date" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-xl-4 form-group">
                      <file_input @file-chosen="upload_tax_file" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                                  :selected_file="new_actions.file_to_upload_file" :hidden_id="'file_to_upload_file'"></file_input>
                      <div v-if="errors_file_upload" class="vvERROR">Please select a file</div>
                    </div>
                  </div>
                  <!-- Sent 64/8 to HMRC -->
                  <div v-if="action === 'sent_64_8_to_hmrc'" class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Date signed 64/8 form sent to HMRC</h4>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="Date 64/8 sent to HMRC" tag="div">
                        <label class="form-label" for="date_64_8_sent_hmrc">Date 64/8 sent to HMRC</label>
                        <datepicker v-model="new_actions.date_64_8_sent_hmrc" id="date_64_8_sent_hmrc" name="date_64_8_sent_hmrc"
                                    :input-class="['date-input', 'requiredField', classes]"
                                    :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_date_64_8_sent_hmrc" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="Consultant who sent 64/8 to HMRC" tag="div" class="form-group">
                        <label class="form-label" for="user_64_8_sent_hmrc">Consultant who sent 64/8 to HMRC</label>
                        <multiselect v-model="new_actions.user_64_8_sent_hmrc" id="user_64_8_sent_hmrc" class="requiredField" :class="classes" name="user_64_8_sent_hmrc"
                                     placeholder="" :custom-label="consultant_label"
                                     label="name" :options="ms_opts.commission_users"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Authentication code for accounts -->
                  <div v-if="action === 'auth_code_received'" class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Please Enter the Date the 64/8 Authentication code was received and the code itself.</h4>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="68/8 Auth code received date" tag="div">
                        <label class="form-label" for="auth_code_date">68/8 Auth code received date</label>
                        <datepicker v-model="new_actions.auth_code_date" id="auth_code_date" name="auth_code_date" :input-class="['date-input', 'requiredField', classes]"
                                    :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_auth_code_date" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required|hmrc_648_auth_code" v-slot="{errors, classes}" name="68/8 Authentication Code" tag="div">
                        <label class="form-label" for="auth_code">68/8 Authentication Code</label>
                        <input type="text" v-model="new_actions.auth_code" id="auth_code" name="auth_code" class="form-input requiredField" :class="classes" maxlength="10"
                               @input="forceUppercase($event, new_actions, 'auth_code')">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Quickfile Account created -->
                  <div v-if="action === 'quickfile_account_created'" class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Enter the date the users QuickFile Account was created.</h4>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="QuickFile Account Created Date" tag="div">
                        <label class="form-label" for="quickfile_account_created_date">QuickFile Account Created Date</label>
                        <datepicker v-model="new_actions.quickfile_account_created_date" id="quickfile_account_created_date" name="quickfile_account_created_date"
                                    :input-class="['date-input', 'requiredField', classes]"
                                    :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_date_quickfile_ac_created" :use-utc="true"></datepicker>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-xl-6 form-group">
                      <ValidationProvider rules="required" v-slot="{errors, classes}" name="Who created QuickFile Account" tag="div" class="form-group">
                        <label class="form-label" for="quickfile_accounts_creator">Who created QuickFile Account</label>
                        <multiselect v-model="new_actions.quickfile_accounts_creator" id="quickfile_accounts_creator" class="requiredField" :class="classes"
                                     name="quickfile_accounts_creator" placeholder="" label="name" :options="ms_opts.commission_users"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
                  <div class="row">
                    <div class="col-xl-6">
                      <button @click.prevent="cancel_action" class="btn orcaBtn grey_bg w-100 sm_btn">Cancel Action</button>
                    </div>
                    <div class="col-xl-6">
                      <button type="submit" class="btn orcaBtn w-100 sm_btn" :disabled="saving">
                        <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving ...</span>
                        <span v-else>Save</span>
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </b-card>
        </div>
        <div class="col-12">
          <b-card header="Tax Documents" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <tr style="background: #efefef;">
                  <th>Document</th>
                  <th>Date sent to worker</th>
                  <th>Date received from worker</th>
                  <th>View Document</th>
                  <th>Uploaded By</th>
                  <th>Sent to HMRC (Date&nbsp;-&nbsp;By)</th>
                  <th>Authorisation Code</th>
                  <th>Authorisation Received from HMRC (Date&nbsp;-&nbsp;By)</th>
                </tr>
                <tr>
                  <td style="vertical-align: middle;">Self Assessment Declaration</td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.docs_sent_date !== null">{{ tax_hmrc.docs_sent_date | formatDate }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.received_self_ass_dec_form_date !== null">{{ tax_hmrc.received_self_ass_dec_form_date | formatDate }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" class="text-center" v-if="tax_hmrc.self_ass_dec_form_file_path !== null">
                    <button @click="view_file_modal('Self Assessment Declaration')" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                            title="View File"><i class="fas fa-eye"></i></button>
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.self_ass_dec_form_uploaded_by_id !== null && 'self_ass_dec_form_uploaded_by' in tax_hmrc && tax_hmrc.self_ass_dec_form_uploaded_by !== null ">
                    {{ tax_hmrc.self_ass_dec_form_uploaded_by.first_name }} {{ tax_hmrc.self_ass_dec_form_uploaded_by.surname }}
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;">-</td>
                  <td style="vertical-align: middle;">-</td>
                  <td style="vertical-align: middle;">-</td>
                </tr>
                <tr>
                  <td style="vertical-align: middle;">Terms of Engagement</td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.docs_sent_date !== null">{{ tax_hmrc.docs_sent_date | formatDate }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.received_terms_engagement_date !== null">{{ tax_hmrc.received_terms_engagement_date | formatDate }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" class="text-center" v-if="tax_hmrc.terms_engagement_file_path !== null">
                    <button @click="view_file_modal('Terms of Engagement')" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                            title="View File"><i class="fas fa-eye"></i></button>
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.terms_engagement_uploaded_by_id !== null && 'terms_engagement_uploaded_by' in tax_hmrc &&
                  tax_hmrc.terms_engagement_uploaded_by !== null">
                    {{ tax_hmrc.terms_engagement_uploaded_by.first_name }} {{ tax_hmrc.terms_engagement_uploaded_by.surname }}
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;">-</td>
                  <td style="vertical-align: middle;">-</td>
                  <td style="vertical-align: middle;">-</td>
                </tr>
                <tr>
                  <td style="vertical-align: middle;">HMRC 64/8</td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.docs_sent_date !== null">{{ tax_hmrc.docs_sent_date | formatDate }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.received_hmrc_648_date !== null">{{ tax_hmrc.received_hmrc_648_date | formatDate }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" class="text-center" v-if="tax_hmrc.hmrc_648_file_path !== null">
                    <button @click="view_file_modal('HMRC 64/8')" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                            title="View File"><i class="fas fa-eye"></i></button>
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.hmrc_648_uploaded_by_id !== null && 'hmrc_648_uploaded_by' in tax_hmrc && tax_hmrc.hmrc_648_uploaded_by !==
                  null">
                    {{ tax_hmrc.hmrc_648_uploaded_by.first_name }} {{ tax_hmrc.hmrc_648_uploaded_by.surname }}
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.sent_hmrc_648_date !== null && tax_hmrc.sent_hmrc_648_by_id !== null && 'sent_hmrc_648_by' in tax_hmrc &&
                  tax_hmrc.sent_hmrc_648_by !== null">
                    {{ tax_hmrc.sent_hmrc_648_date | formatDate }}<br>
                    {{ tax_hmrc.sent_hmrc_648_by.first_name }} {{ tax_hmrc.sent_hmrc_648_by.surname }}
                  </td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.received_auth_code !== null">{{ tax_hmrc.received_auth_code }}</td>
                  <td v-else></td>
                  <td style="vertical-align: middle;" v-if="tax_hmrc.received_auth_code_date !== null && tax_hmrc.received_auth_code_by_id !== null &&
                  'hmrc_648_authorisation_by' in tax_hmrc && tax_hmrc.hmrc_648_authorisation_by !== null">
                    {{ tax_hmrc.received_auth_code_date | formatDate }}<br>
                    {{ tax_hmrc.hmrc_648_authorisation_by.first_name }} {{ tax_hmrc.hmrc_648_authorisation_by.surname }}
                  </td>
                  <td v-else></td>
                </tr>
              </table>
            </div>

            <div class="row" v-if="tax_hmrc.quickfile_account_created_by_id !== null && tax_hmrc.quickfile_account_created_date !== null">
              <div class="col-12">
                <h5>QuickFile Account Created</h5>
              </div>
              <div class="col-xl-6 form-group">
                <label class="form-label" for="qf_a_created_by">QuickFile Account Created By</label>
                <p v-if="'commission_user' in tax_hmrc && tax_hmrc.commission_user !== null" id="qf_a_created_by">
                  {{ tax_hmrc.commission_user.first_name }} {{ tax_hmrc.commission_user.surname }}
                </p>
              </div>
              <div class="col-xl-6 form-group">
                <label class="form-label" for="qf_a_created_date">QuickFile Account Created Date</label>
                <p id="qf_a_created_date">{{ tax_hmrc.quickfile_account_created_date | formatDate }}</p>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-12" v-if="tax_hmrc.received_auth_code !== null">
          <b-card header="Tax Returns" header-tag="h4" body-class="mb-3 pb-2">
            <ValidationObserver ref="saveTaxReturnForm" slim>
              <form role="form" @submit.prevent="save_tax_return">
                <div class="row">
                  <div class="col-xl-4">
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Type of Tax Return to be Uploaded" tag="div" class="form-group">
                      <label class="form-label" for="tax_return_type">Type of Tax Return to be Uploaded</label>
                      <multiselect v-model="tax_return.tax_return_type" id="tax_return_type" class="requiredField" :class="classes" name="tax_return_type" placeholder=""
                                   :options="ms_opts.upload_tax_return_type"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div v-if="tax_return.tax_return_type === 'Authorised Return'" class="col-xl-2 form-group">
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Authorised Date" tag="div">
                      <label class="form-label" for="signed_date">Authorised Date</label>
                      <datepicker v-model="tax_return.signed_date" id="signed_date" name="signed_date" :input-class="['date-input', 'requiredField', classes]"
                                  :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_tax_return_signed_date" :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div v-if="tax_return.tax_return_type !== null" class="col-xl-2">
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Tax Return Year" tag="div" class="form-group">
                      <label class="form-label" for="tax_return_year">Tax Return Year</label>
                      <multiselect v-model="tax_return.tax_return_year" id="tax_return_year" class="requiredField" :class="classes" name="tax_return_year" placeholder=""
                                   :options="ms_opts.tax_return_years"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div v-if="tax_return.tax_return_type !== null" class="form-group" :class="[tax_return.tax_return_type === 'Authorised Return' ? 'col-xl-4' : 'col-xl-6']">
                    <file_input @file-chosen="upload_tax_return" :required="false" :accepted_file_type="'image/*,.pdf,.doc,.docx'"
                                :selected_file="tax_return.tax_return_upload_file" :hidden_id="'tax_return_upload_file'"></file_input>
                    <div v-if="errors_file_upload" class="vvERROR">Please select a file</div>
                  </div>
                  <div v-if="tax_return.tax_return_type !== null" class="col-xl-6 offset-xl-6">
                    <button type="submit" class="btn orcaBtn w-100 sm_btn" :disabled="saving_2">
                      <span v-if="saving_2" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving ...</span>
                      <span v-else>Save</span>
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
            <hr>
            <div v-if="!notEmptyObject(tax_returns)" class="row">
              <div class="col-12">
                <h5 class="font-weight-bold">No Tax Returns Completed</h5>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <tr style="background: #efefef;">
                      <th>Return for Year</th>
                      <th>View</th>
                      <th>Email Sent</th>
                      <th>Worker Authorised Date</th>
                    </tr>
                    <tr v-for="tr in tax_returns">
                      <td>{{ tr.return_for_year }}</td>
                      <td>
                        <a :href="'https://geniusmoney.co.uk/view/tax-return?id=' + tr.tax_return_hash" target="_blank" class="btn orcaBtn greenBtn sm-btn">
                          <i class="far fa-eye"></i>
                        </a>
                      </td>
                      <td>{{ tr.created_at | formatDateTime }}</td>
                      <td>{{ tr.signed_date | formatDate }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </b-card>
        </div>

        <!-- Cancel Tax Service -->
        <div class="col-12">
          <b-card header="Cancel Genius Tax Service" header-tag="h4" body-class="mb-3 pb-2">
            <div class="row">
              <div class="col-12">
                <h4 class="font-weight-bold bp_color mb-0">{{ worker.full_name }} is currently signed into the Genius Tax Service</h4>
              </div>
              <div class="col-12">
                <div class="row">
                  <label class="col-xl-8 cardLabel">If they no longer wish to use this service please click the cancel button.</label>
                  <div class="col-md-4 form-group">
                    <button @click="cancel_tax_service" class="btn orcaBtn danger w-100 sm_btn">Cancel Tax Service</button>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import file_input from 'partials/files/fileInputNOLIMIT';
import Multiselect from "vue-multiselect";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "genius_tax",
  props: ['tax_hmrc', 'tax_hmrc_loaded', 'worker', 'tax_returns'],
  components: {loadingCube, file_input, Multiselect, Datepicker},
  data() {
    return {
      saving: false,
      saving_2: false,

      ms_opts: {
        commission_users: [],
        file_to_upload: ['Self Assessment Declaration', 'Terms of Engagement', 'HMRC 64/8'],
        upload_tax_return_type: ['Requires Authorisation', 'Authorised Return'],
        tax_return_years: ['16/17', '17/18', '18/19', '19/20', '20/21', '21/22', '22/23', '23/24', '24/25']
      },

      w_services: this.worker.rel_services,
      tax_details: {},
      show_action_buttons: true,
      action: '',
      new_actions: {
        signup_date: null,
        commission_user: null,
        docs_sent_date: null,

        file_to_upload: null,
        file_received_date: null,
        file_to_upload_file: null,

        date_64_8_sent_hmrc: null,
        user_64_8_sent_hmrc: null,

        auth_code_date: null,
        auth_code: 'SA',
        auth_code_by: this.$store.state.auth.me.id,

        quickfile_accounts_creator: null,
        quickfile_account_created_date: null,
      },

      tax_return: {
        tax_return_type: null,
        tax_return_year: null,
        signed_date: null,
        tax_return_upload_file: null,
      },

      errors_file_upload: false,

      check_up_file_1: false,
      check_up_file_2: false,
      check_up_file_3: false,
    }
  },
  beforeMount() {
    if (this.tax_hmrc_loaded) {
      this.tax_details = this.tax_hmrc;
    }

    axios.get(this.crmApiPath + 'user/index').then(users => this.ms_opts.commission_users = users.data);
    if (this.tax_hmrc.hmrc_648_file_path !== null) {
      this.check_up_file_3 = true;
      for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
        if (this.ms_opts.file_to_upload[i] === 'HMRC 64/8') {
          this.ms_opts.file_to_upload.splice(i, 1);
          i--;
        }
      }
    }
    if (this.tax_hmrc.self_ass_dec_form_file_path !== null) {
      this.check_up_file_1 = true;
      for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
        if (this.ms_opts.file_to_upload[i] === 'Self Assessment Declaration') {
          this.ms_opts.file_to_upload.splice(i, 1);
          i--;
        }
      }
    }
    if (this.tax_hmrc.terms_engagement_file_path !== null) {
      this.check_up_file_2 = true;
      for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
        if (this.ms_opts.file_to_upload[i] === 'Terms of Engagement') {
          this.ms_opts.file_to_upload.splice(i, 1);
          i--;
        }
      }
    }
  },
  methods: {
    sign_up_to_tax_service() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Tax Service Sign Up</div>' +
            '<div class="snotifyToast__body">' +
            'Please confirm<br><br>' + this.worker.person.first_name + ' ' + this.worker.person.surname + '<br><br>Wants to sign up for Genius Tax Service.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              this.w_services.genius_tax = true;
              this.w_services.log_by_type = 'App\\Models\\Users\\User';
              this.w_services.log_by_id = this.$store.state.auth.me.id;
              axios.patch(this.crmApiPath + 'worker/services/' + this.w_services.id, this.w_services).then(() => {

                let genius_tax = {
                  worker_id: this.worker.id,
                  commission_user_id: this.$store.state.auth.me.id,
                  signup_date: this.$moment().format('YYYY-MM-DD'),
                  log_by_id: this.$store.state.auth.me.id,
                  log_by_type: 'App\\Models\\Users\\User'
                };
                // save genius tax record
                axios.post(this.crmApiPath + 'worker/tax_genius', genius_tax).then(() => {
                this.$nextTick(() => { // reload info
                    this.$bus.$emit('worker_tax_hmrc::reload', {action: true});
                    this.$bus.$emit('logs::reload', {action: true});
                    setTimeout(() => {
                        this.$snotify.success(this.worker.person.first_name + ' ' + this.worker.person.surname + ' : Signed up to Tax Service');
                    }, 500);
                });

                });
              });
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    cancel_tax_service() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Cancel Tax Service</div>' +
            '<div class="snotifyToast__body">' +
            'Please confirm<br><br>' + this.worker.person.first_name + ' ' + this.worker.person.surname + '<br><br>Wants to cancel their Genius Tax Service.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              this.w_services.genius_tax = false;
              this.w_services.log_by_type = this.tax_details.log_by_type = 'App\\Models\\Users\\User';
              this.w_services.log_by_id = this.tax_details.log_by_id = this.$store.state.auth.me.id;
              axios.patch(this.crmApiPath + 'worker/services/' + this.w_services.id, this.w_services).then(() => {
                axios.delete(this.crmApiPath + 'worker/tax_genius/' + this.tax_details.id, {data: this.tax_details}).then(() => {
                  // reload info
                  this.$nextTick(() => {
                    this.$bus.$emit('worker_tax_hmrc::reload', {action: true});
                    this.$bus.$emit('logs::reload', {action: true});
                    setTimeout(() => {
                        this.$snotify.success(this.worker.person.first_name + ' ' + this.worker.person.surname + ' : Tax Service Cancelled');
                    }, 500);
                  });
                })
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },

    take_action(action) {
      this.show_action_buttons = false;
      this.action = action;
    },

    consultant_label({first_name, surname}) {
      return `${first_name} ${surname}`;
    },

    /* Date Format for datepicker & Datepicker selections */
    dateFormat(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    select_new_signup_date(signup_date) {
      if (signup_date != null) {
        this.new_actions.signup_date = this.$moment(signup_date).format('YYYY-MM-DD');
      }
    },
    select_docs_manually_sent_date(docs_sent_date) {
      if (docs_sent_date != null) {
        this.new_actions.docs_sent_date = this.$moment(docs_sent_date).format('YYYY-MM-DD');
      }
    },
    select_file_received_date(file_received_date) {
      if (file_received_date !== null) {
        this.new_actions.file_received_date = this.$moment(file_received_date).format('YYYY-MM-DD');
      }
    },
    select_date_64_8_sent_hmrc(date_64_8_sent_hmrc) {
      if (date_64_8_sent_hmrc !== null) {
        this.new_actions.date_64_8_sent_hmrc = this.$moment(date_64_8_sent_hmrc).format('YYYY-MM-DD');
      }
    },
    select_auth_code_date(auth_code_date) {
      if (auth_code_date !== null) {
        this.new_actions.auth_code_date = this.$moment(auth_code_date).format('YYYY-MM-DD');
      }
    },
    select_date_quickfile_ac_created(date_quickfile_ac) {
      if (date_quickfile_ac !== null) {
        this.new_actions.quickfile_account_created_date = this.$moment(date_quickfile_ac).format('YYYY-MM-DD');
      }
    },
    select_tax_return_signed_date(tax_return_signed_date) {
      if (tax_return_signed_date !== null) {
        this.tax_return.signed_date = this.$moment(tax_return_signed_date).format('YYYY-MM-DD');
      }
    },

    /* File upload selection */
    upload_tax_file(file) {
      this.new_actions.file_to_upload_file = file;
    },
    upload_tax_return(file) {
      this.tax_return.tax_return_upload_file = file;
    },

    save_action() {
      if (this.new_actions.file_to_upload_file === null && this.action === 'upload_received_docs') {
        this.errors_file_upload = true;
      }
      else {
        this.errors_file_upload = false;
        this.$refs.saveActionForm.validate().then(success => {
          if (!success) {
            this.formErrorsValidationScroll(this.$refs.saveActionForm);
          }
          else {
            this.saving = true;
            this.$parent.tax_hmrc_loaded = false;
            this.$nextTick(() => {
              this.tax_details.log_by_id = this.$store.state.auth.me.id;
              this.tax_details.log_by_type = 'App\\Models\\Users\\User';

              if (this.action === 'change_sign_up_date') {
                this.tax_details.signup_date = this.new_actions.signup_date
              }
              if (this.action === 'change_commission_consultant') {
                this.tax_details.commission_user_id = this.new_actions.commission_user.id
              }
              if (this.action === 'docs_manually_sent') {
                this.tax_details.docs_sent_date = this.new_actions.docs_sent_date
              }

              if (this.action === 'sent_64_8_to_hmrc') {
                this.tax_details.sent_hmrc_648_date = this.new_actions.date_64_8_sent_hmrc;
                this.tax_details.sent_hmrc_648_by_id = this.new_actions.user_64_8_sent_hmrc.id;
              }
              if (this.action === 'auth_code_received') {
                this.tax_details.received_auth_code_date = this.new_actions.auth_code_date;
                this.tax_details.received_auth_code = this.new_actions.auth_code;
                this.tax_details.received_auth_code_by_id = this.new_actions.auth_code_by;
              }
              if (this.action === 'quickfile_account_created') {
                this.tax_details.quickfile_account_created_by_id = this.new_actions.quickfile_accounts_creator.id;
                this.tax_details.quickfile_account_created_date = this.new_actions.quickfile_account_created_date;
              }
              if (this.action !== 'upload_received_docs') {
                axios.patch(this.crmApiPath + 'worker/tax_genius/' + this.tax_details.id, this.tax_details).then(() => {
                  this.$nextTick(() => {
                    this.$snotify.success('Tax Information Updated For: ' + this.worker.person.first_name + ' ' + this.worker.person.surname);
                    this.saving = false;
                    this.$bus.$emit('worker_tax_hmrc::reload', {action: true});
                    this.$bus.$emit('logs::reload', {action: true});
                    this.reset_new_actions();
                    this.show_action_buttons = true;
                  });
                })
              }
              else if (this.action === 'upload_received_docs') {
                // transform object into form data
                let file_received = new FormData();
                let temp_file_name = this.new_actions.file_to_upload.replace(/ /g, "_");
                temp_file_name = temp_file_name.replace(/\//g, "_");
                let file_name = temp_file_name + '-' + this.$moment().format('DDMMYYHHmmss') + '.' +
                    /[^.]*$/.exec(this.new_actions.file_to_upload_file.name.replace(/ /g, "-"))[0];
                file_received.append('worker_id', this.tax_hmrc.worker_id);
                // information depending on file to be uploaded type
                if (this.new_actions.file_to_upload === 'Self Assessment Declaration') {
                  file_received.append('received_self_ass_dec_form_date', this.new_actions.file_received_date);
                  file_received.append('self_ass_dec_form_file_path', 'storage/worker_files/tax_docs/' + this.worker.id + '/' + file_name);
                  file_received.append('self_ass_dec_form_uploaded_by_id', this.$store.state.auth.me.id);
                  for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
                    if (this.ms_opts.file_to_upload[i] === 'Self Assessment Declaration') {
                      this.ms_opts.file_to_upload.splice(i, 1);
                      i--;
                    }
                  }
                }
                if (this.new_actions.file_to_upload === 'Terms of Engagement') {
                  file_received.append('received_terms_engagement_date', this.new_actions.file_received_date);
                  file_received.append('terms_engagement_file_path', 'storage/worker_files/tax_docs/' + this.worker.id + '/' + file_name);
                  file_received.append('terms_engagement_uploaded_by_id', this.$store.state.auth.me.id);
                  for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
                    if (this.ms_opts.file_to_upload[i] === 'Terms of Engagement') {
                      this.ms_opts.file_to_upload.splice(i, 1);
                      i--;
                    }
                  }
                }
                if (this.new_actions.file_to_upload === 'HMRC 64/8') {
                  file_received.append('received_hmrc_648_date', this.new_actions.file_received_date);
                  file_received.append('hmrc_648_file_path', 'storage/worker_files/tax_docs/' + this.worker.id + '/' + file_name);
                  file_received.append('hmrc_648_uploaded_by_id', this.$store.state.auth.me.id);
                  for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
                    if (this.ms_opts.file_to_upload[i] === 'HMRC 64/8') {
                      this.ms_opts.file_to_upload.splice(i, 1);
                      i--;
                    }
                  }
                }
                // uploaded file
                file_received.append('file_name', file_name);
                file_received.append('file_path', 'storage/worker_files/tax_docs/' + this.worker.id + '/');
                file_received.append('uploaded_file', this.new_actions.file_to_upload_file);
                // Log values
                file_received.append('log_by_id', this.$store.state.auth.me.id);
                file_received.append('log_by_type', 'App\\Models\\Users\\User');
                // CHANGE AXIOS FROM POST TO PATCH - DEAL WITH FILE UPLOAD
                file_received.append('_method', 'patch');

                // make the axios call to save the file
                axios.post(this.crmApiPath + 'worker/tax_genius/' + this.tax_details.id, file_received, {
                  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then((res) => {
                  this.$nextTick(() => {
                    this.$snotify.success('Tax Document Uploaded for: ' + this.worker.person.first_name + ' ' + this.worker.person.surname);
                    this.saving = false;
                    this.$bus.$emit('worker_tax_hmrc::reload', {action: true});
                    this.$bus.$emit('logs::reload', {action: true});
                    this.reset_new_actions();
                    this.show_action_buttons = true;
                  });
                })
              }
            });
          }
        });
      }

    },

    view_file_modal(type) {
      let file_type = null, file_path = null, file_uploaded_by = null, file_uploaded_date = null;

      if (type === 'Self Assessment Declaration') {
        file_type = type;
        file_path = this.tax_hmrc.self_ass_dec_form_file_path;
        file_uploaded_by = this.tax_hmrc.self_ass_dec_form_uploaded_by;
        file_uploaded_date = this.tax_hmrc.received_self_ass_dec_form_date;
      }
      else if (type === 'Terms of Engagement') {
        file_type = type;
        file_path = this.tax_hmrc.terms_engagement_file_path;
        file_uploaded_by = this.tax_hmrc.terms_engagement_uploaded_by;
        file_uploaded_date = this.tax_hmrc.received_terms_engagement_date;
      }
      else if (type === 'HMRC 64/8') {
        file_type = type;
        file_path = this.tax_hmrc.hmrc_648_file_path;
        file_uploaded_by = this.tax_hmrc.hmrc_648_uploaded_by;
        file_uploaded_date = this.tax_hmrc.received_hmrc_648_date;
      }

      this.$store.commit('SHOW_VIEW_TAX_FILE_MODAL', {
        tax_file_type: file_type,
        file_path: file_path,
        file_uploaded_by: file_uploaded_by,
        file_uploaded_date: file_uploaded_date
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_tax_file_modal'));
    },

    reset_new_actions() {
      this.new_actions = {
        signup_date: null,
        commission_user: null,
        docs_sent_date: null,

        date_64_8_sent_hmrc: null,
        user_64_8_sent_hmrc: null,

        auth_code_date: null,
        auth_code: 'SA',
        auth_code_by: this.$store.state.auth.me.id,

        quickfile_accounts_creator: null,
        quickfile_account_created_date: null,
      }
    },

    cancel_action() {
      this.tax_details = this.tax_hmrc;
      this.reset_new_actions();
      this.$nextTick(() => this.show_action_buttons = true);
    },

    save_tax_return() {
      if (this.tax_return.tax_return_upload_file === null) {
        this.errors_file_upload = true;
      }
      else {
        this.saving_2 = true;
        this.errors_file_upload = false;
        this.$refs.saveTaxReturnForm.validate().then(success => {
          if (!success) {
            this.formErrorsValidationScroll(this.$refs.saveTaxReturnForm);
          }
          else {
            let file_received = new FormData();

            let temp_file_name = this.tax_return.tax_return_year.replace(/ /g, "_");
            temp_file_name = temp_file_name.replace(/\//g, "_");
            let file_name = temp_file_name + '-tax_return-' + this.$moment().format('DDMMYYHHmmss') + '.' +
                /[^.]*$/.exec(this.tax_return.tax_return_upload_file.name.replace(/ /g, "-"))[0];

            file_received.append('worker_id', this.tax_hmrc.worker_id);
            file_received.append('return_for_year', this.tax_return.tax_return_year);

            if (this.tax_return.tax_return_type === 'Authorised Return') {
              file_received.append('signed_date', this.$moment(this.tax_return.signed_date).format('YYYY-MM-DD HH:mm:ss'));
            }
            file_received.append('return_file', 'public/worker_files/tax_returns/' + this.worker.id + '/' + file_name);

            // uploaded file
            file_received.append('file_name', file_name);
            file_received.append('file_path', 'public/worker_files/tax_returns/' + this.worker.id + '/');
            file_received.append('uploaded_file', this.tax_return.tax_return_upload_file);
            // Log values
            file_received.append('log_by_id', this.$store.state.auth.me.id);
            file_received.append('log_by_type', 'App\\Models\\Users\\User');

            this.$parent.tax_hmrc_loaded = false;

            axios.post(this.crmApiPath + 'worker_tax_returns', file_received, {headers: {'Content-Type': 'application/json'}}).then(() => {
              this.$nextTick(() => {
                this.saving_2 = false;
                this.$bus.$emit('worker_tax_hmrc::reload', {action: true});
                this.$bus.$emit('logs::reload', {type: 'worker', action: true});
                this.reset_new_actions();
                this.show_action_buttons = true;
              });
            });
          }
        });
      }
    }
  },
  watch: {
    tax_hmrc_loaded(val) {
      if (!val) {
        this.tax_details = {};
        this.check_up_file_1 = false;
        this.check_up_file_2 = false;
        this.check_up_file_3 = false;
        this.ms_opts.file_to_upload = ['Self Assessment Declaration', 'Terms of Engagement', 'HMRC 64/8'];
      }
      else {
        this.tax_details = this.tax_hmrc;

        if (this.tax_hmrc.hmrc_648_file_path !== null) {
          this.check_up_file_3 = true;
          for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
            if (this.ms_opts.file_to_upload[i] === 'HMRC 64/8') {
              this.ms_opts.file_to_upload.splice(i, 1);
              i--;
            }
          }
        }
        else {
          this.check_up_file_3 = false;
        }
        if (this.tax_hmrc.self_ass_dec_form_file_path !== null) {
          this.check_up_file_1 = true;
          for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
            if (this.ms_opts.file_to_upload[i] === 'Self Assessment Declaration') {
              this.ms_opts.file_to_upload.splice(i, 1);
              i--;
            }
          }
        }
        else {
          this.check_up_file_1 = false;
        }
        if (this.tax_hmrc.terms_engagement_file_path !== null) {
          this.check_up_file_2 = true;
          for (let i = 0; i < this.ms_opts.file_to_upload.length; i++) {
            if (this.ms_opts.file_to_upload[i] === 'Terms of Engagement') {
              this.ms_opts.file_to_upload.splice(i, 1);
              i--;
            }
          }
        }
        else {
          this.check_up_file_2 = false;
        }
      }
    },
    'tax_hmrc.self_ass_dec_form_file_path'(val) {
      this.check_up_file_1 = val !== null;
    },
    'tax_hmrc.terms_engagement_file_path'(val) {
      this.check_up_file_2 = val !== null;
    },
    'tax_hmrc.hmrc_648_file_path'(val) {
      this.check_up_file_3 = val !== null;
    },
    'tax_return.tax_return_type'(val) {
      this.tax_return.tax_return_year = null;
      this.tax_return.signed_date = null;
      this.tax_return.tax_return_upload_file = null;
    }
  }
}
</script>

<style scoped lang="scss">
#no_tax_sign_up {
  min-height: calc(100vh - 200px) !important;
}

.sm-btn {
  width:       auto;
  padding:     0 15px;
  line-height: 30px;
  font-size:   0.65rem;
}
</style>
